import { SiteHeader } from "@/components/site-header";

export function UserSafetyPage() {
  return (
    <div className="flex flex-col h-full">
      <SiteHeader title="User Safety" />

      <div className="flex flex-col gap-4 flex-1 p-4 lg:p-6">
        {/* Content coming soon */}
      </div>
    </div>
  );
}
